import { Injectable } from "@angular/core";
import { BasicStorage } from "./basic-storage.provider";
import * as firebase from 'firebase';
import { UploadMetadata, StringFormat } from "@firebase/storage-types";

@Injectable()
export class StorageProvider implements BasicStorage {

  public storage = firebase.storage();

  constructor() {}

  put(path: string, data: Blob, metadata?: UploadMetadata) {
    const ref = this.storage.ref(path);
    return ref.put(data, metadata);
  }
  putString(path: string, data: string, format?: StringFormat, metadata?: UploadMetadata) {
    const ref = this.storage.ref(path);
    return ref.putString(data, format, metadata);
  }

}